<template>
    <div class="point-selection">
      <div v-if="loading" class="loading">
        <p>Loading available tours...</p>
      </div>
      
      <div v-else-if="availableTours.length === 0" class="error">
        <p>No tours available for this point</p>
      </div>
      
      <div v-else class="tour-selection">
        <h2>Select a Tour</h2>
        <p>This point is available in multiple tours. Please select which tour you want to continue with:</p>
        
        <TourListItem v-for="tour in availableTours" :tour="tour" :params="params" />
      </div>
    </div>
  </template>
  
  <script>
  import { mapGetters } from 'vuex'
  import { showMultiLingualText } from '../utils/languageUtils'
  import TourListItem from '../components/TourListItem.vue'

  import api from '../services/api'

  export default {
    data() {
      return {
        loading: true,
        availableTours: [],
        pointId: null,
        params: {}
      }
    },
    components: {
      TourListItem
    },
    
    async mounted() {
      this.pointId = this.$route.params.pointId

      await this.loadAvailableTours()
    },
    computed: {
      ...mapGetters('tours', ['activeTour'])
    },
    
    methods: {
      showMultiLingualText(text, altText = null, showFirstLanguage = false) {
        return showMultiLingualText(text, altText, showFirstLanguage, this.$i18n.locale)
      },
      async loadAvailableTours() {
        try {
          const response = await api.getPoint(this.pointId)
          console.log("response", response)
          if (response.data) {
            console.log("response data", response.data);

            console.log("available tours", response.data.tour_points.map(tp => tp.tour));

            // add unique tours to the availableTours array
            this.availableTours = [...new Map(
              (response.data?.tour_points?.map(tp => tp.tour) ?? [])
              .map(tour => [tour.id, tour])
            ).values()];
          }
        } catch (error) {
          console.error('Error loading tours:', error)
          this.$router.push('/not-found')
        } finally {
          this.loading = false
        }
      }
    }
  }
  </script>